import { Component, Input, OnChanges } from '@angular/core';
import * as FaIcons from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'wsb-ui-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  standalone: false
})
export class IconComponent implements OnChanges {
  @Input() icon: string;

  faIcon: FaIcons.IconDefinition;

  constructor() {}

  ngOnChanges(): void {
    if (FaIcons[this.icon] !== undefined) {
      this.faIcon = FaIcons[this.icon];
    }
  }
}
